import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { Menu, X, ArrowRight } from "lucide-react";
import { trackEvent } from "../../lib/analytics";

const NAV = [
  { to: "/", label: "Home" },
  { to: "/stations", label: "Format & Stations" },
  { to: "/simulation", label: "Simulation" },
  { to: "/schedule", label: "Schedule" },
  { to: "/events", label: "Events" },
  { to: "/results", label: "Leaderboard" },
  { to: "/videos", label: "Videos" },
  { to: "/merch", label: "Merch" },
  { to: "/gear", label: "Gear" },
  { to: "/blog", label: "Blog" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);

  return (
    <header className="fixed top-0 inset-x-0 z-50 bg-[#070707]/85 backdrop-blur-xl border-b border-white/10">
      <div className="max-w-7xl mx-auto px-5 lg:px-8 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-baseline gap-2 group">
          <span className="font-head font-black uppercase text-2xl tracking-tight leading-none">
            HYROX<span className="text-volt">NINJA</span>
          </span>
          <span className="hidden sm:block font-mono2 text-[9px] uppercase tracking-[0.25em] text-zinc-500 group-hover:text-zinc-300 transition-colors">
            Dallas Performance Systems × NinjAthlete
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-5">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-link-${n.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className={({ isActive }) =>
                `font-head uppercase tracking-wide text-sm font-700 transition-colors ${
                  isActive ? "text-volt" : "text-zinc-300 hover:text-white"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link
            to="/events"
            data-testid="nav-book-now-button"
            className="btn-volt !py-2 !px-4 !text-sm"
            onClick={() => trackEvent("booking_click", { placement: "nav", service: "general" })}
          >
            Book Now <ArrowRight size={15} />
          </Link>
        </nav>

        <button
          data-testid="nav-mobile-toggle"
          className="lg:hidden text-white"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={26} /> : <Menu size={26} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="lg:hidden bg-[#0a0a0a] border-t border-white/10 px-5 py-6 flex flex-col gap-4">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={() => setOpen(false)}
              className={({ isActive }) =>
                `font-head uppercase text-2xl font-extrabold ${isActive ? "text-volt" : "text-white"}`
              }
            >
              {n.label}
            </NavLink>
          ))}
          <Link to="/events" className="btn-volt w-fit mt-2" data-testid="nav-mobile-book-button" onClick={() => { setOpen(false); trackEvent("booking_click", { placement: "nav_mobile", service: "general" }); }}>
            Book Now <ArrowRight size={16} />
          </Link>
        </div>
      )}
    </header>
  );
};
